import { create } from 'zustand';
import api from '../api/api';
import { notificationApi } from '../api/notification';

let sseController = null;
let reconnectTimer = null;

export const useNotificationStore = create((set, get) => ({
  unreadCount: 0,
  loading: false,
  error: null,

  // SSE 연결
  connectSse: async () => {
    const token = localStorage.getItem('POSTPOP_AUTH_TOKEN');
    if (!token || sseController) return;
    if (typeof document !== 'undefined' && document.hidden) return;

    sseController = new AbortController();
    const currentController = sseController;

    try {
      const url = `${api.defaults.baseURL}/notifications/stream`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'text/event-stream',
        },
        signal: currentController.signal,
      });

      if (!response.ok) throw new Error(`SSE connection failed: ${response.status}`);

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        let currentEvent = '';
        let currentData = '';

        for (const line of lines) {
          if (line.startsWith('event: ')) {
            currentEvent = line.slice(7);
          } else if (line.startsWith('data: ')) {
            currentData = line.slice(6);
          } else if (line === '' && currentEvent && currentData) {
            if (currentEvent === 'notification') {
              try {
                const parsed = JSON.parse(currentData);
                set({ unreadCount: parsed.unreadCount });
              } catch (e) {
                console.error('Failed to parse SSE data:', e);
              }
            }
            currentEvent = '';
            currentData = '';
          }
        }
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('SSE error:', err);
      }
    } finally {
      if (sseController === currentController) {
        sseController = null;
      }
      const isVisible = typeof document === 'undefined' || !document.hidden;
      if (!currentController.signal.aborted && isVisible) {
        reconnectTimer = setTimeout(() => {
          get().connectSse();
        }, 3000);
      }
    }
  },

  // SSE 연결 종료
  disconnectSse: () => {
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    if (sseController) {
      sseController.abort();
      sseController = null;
    }
  },

  // 읽지 않은 알림 수 조회
  fetchUnreadCount: async () => {
    try {
      const response = await notificationApi.getUnreadCount();
      set({ unreadCount: response.data.count });
    } catch (err) {
      console.error('Failed to fetch unread count:', err);
    }
  },

  // 알림 읽음 처리 후 카운트 감소
  decrementUnreadCount: () => {
    const currentCount = get().unreadCount;
    if (currentCount > 0) {
      set({ unreadCount: currentCount - 1 });
    }
  },

  // 카운트 리셋
  resetUnreadCount: () => {
    set({ unreadCount: 0 });
  },
}));
